
<template>
<div class=" background-01">
  <v-layout row wrap >
    <v-flex xs12 sm12 text-xs-center>
      <ui-title-red textTitle=" Errores comunes en la administración del dinero"></ui-title-red>      
      <ui-simple-lsc @hideVideo="hideVideo" :vidTittle="'Errores comunes en la administración del dinero'" videoEmbed="ADMINISTRACIONDINERO56Errores.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex  v-if="videoAcc" xs12 mb-5>
      <video-app class="adorn-bottom" :videoSize="700" vidTittle="video Presentacion" youtubeEmbed="9KuYnJNfQHU?autoplay=1&rel=0"></video-app>
    </v-flex>

  </v-layout>    
</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      videoAcc: true
    };
  },
  methods: {
    hideVideo(video) {
      this.videoAcc = !video
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-56.vue?25ff66c8